import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import ServiceBase from '../base'
import { ICustomConfig } from '../../types'

const defaultClientConfig = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
  },
}

class AxiosService extends ServiceBase {
  private httpClient = axios.create(defaultClientConfig)

  public async request<TResult = any>(
    config: AxiosRequestConfig,
    customConfig: ICustomConfig<TResult> = {},
  ) {
    let response: AxiosResponse<any> | undefined

    if (!config.baseURL) {
      config.baseURL = this.baseURL
    }

    const requestConfig = await this.requestMiddleware.reduce(
      (c, middleware) => middleware(c),
      config,
    )
    response = await this.httpClient.request(requestConfig) as AxiosResponse<any>

    this.responseMiddleware.reduce((r, middleware) => middleware(r), response)

    const mapResponse =
      customConfig.mapResponse || ((r: AxiosResponse) => r.data)
    return mapResponse(response)
  }
}

export default AxiosService
